import { render, staticRenderFns } from "./EditPannel.vue?vue&type=template&id=ffd348a0&"
import script from "./EditPannel.vue?vue&type=script&lang=js&"
export * from "./EditPannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports